!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("react-router-dom"), require("invariant"), require("hoist-non-react-statics")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-router-dom", "invariant", "hoist-non-react-statics"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).keepaliveRouter = {}, e.React, e.reactRouterDom, e.invariant, e.hoistNonReactStatic);
}(this, function (e, f, b, t, r) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var O = n(f),
      g = n(t),
      u = n(r);

  function E(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function c(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function i(e, t, r) {
    return t && c(e.prototype, t), r && c(e, r), e;
  }

  function S(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function l() {
    return (l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r,
            n = arguments[t];

        for (r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function o(t, e) {
    var r,
        n = Object.keys(t);
    return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(t), e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r)), n;
  }

  function k(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? o(Object(r), !0).forEach(function (e) {
        S(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }

    return t;
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && p(e, t);
  }

  function a(e) {
    return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function p(e, t) {
    return (p = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function j(e, t) {
    if (null == e) return {};

    var r,
        n = function (e, t) {
      if (null == e) return {};

      for (var r, n = {}, c = Object.keys(e), o = 0; o < c.length; o++) {
        r = c[o], 0 <= t.indexOf(r) || (n[r] = e[r]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) for (var c = Object.getOwnPropertySymbols(e), o = 0; o < c.length; o++) {
      r = c[o], 0 <= t.indexOf(r) || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }

  function R(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function h(r) {
    var n = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var e,
          t = a(r);
      return e = n ? (e = a(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" != typeof e && "function" != typeof e ? R(t) : e;
    };
  }

  function d(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          c = !1,
          o = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        c = !0, o = e;
      } finally {
        try {
          n || null == u.return || u.return();
        } finally {
          if (c) throw o;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return y(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return y(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function y(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var v = f.createContext(),
      m = "KEEPLIVE_ROUTE_COMPONENT",
      w = "created",
      C = "active",
      T = "actived",
      D = "unActive",
      P = "unActived",
      I = "destoryed";

  function _(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }

  function A(e) {
    return "Function" === _(e);
  }

  var x = [],
      K = {},
      M = {};

  function N(e, t) {
    e[t].state !== T && (e[t].lastState = e[t].state, e[t].state = "destory", e[t].load = null);
  }

  function L() {
    return f.useReducer(function (t, e) {
      var r,
          n = e.type,
          c = e.payload;

      switch (n) {
        case w:
          var o = c.cacheId,
              a = c.children,
              u = c.load,
              i = t[o] && "destory" === t[o].state;
          return t[o] && !i || (t[o] = {
            children: a,
            state: w,
            lastState: i ? "destory" : "",
            load: u
          }), t;

        case C:
          return t[c.cacheId] && (u = {}, c.load && (u.load = c.load), t[c.cacheId] = k(k({}, t[c.cacheId]), {}, {
            lastState: t[c.cacheId].state,
            state: C
          }, u)), k({}, t);

        case T:
          return t[c] && (t[c] = k(k({}, t[c]), {}, {
            lastState: t[c].state,
            state: T
          }), (r = K[c]) && A(r) && r(T)), k({}, t);

        case D:
          return t[c] && (t[c] = k(k({}, t[c]), {}, {
            lastState: t[c].state,
            state: D
          })), k({}, t);

        case P:
          return t[c] && (t[c] = k(k({}, t[c]), {}, {
            lastState: t[c].state,
            state: P
          }), (r = K[c]) && A(r) && r(P)), k({}, t);

        case "reset":
          return "String" === _(c) && t[c] ? N(t, c) : "Array" === _(c) ? c.forEach(function (e) {
            t[e] && N(t, e);
          }) : c || Object.keys(t).forEach(function (e) {
            N(t, e);
          }), t;

        case I:
          return delete t[c], k({}, t);

        case "clear":
          return Object.keys(t).forEach(function (e) {
            t[e].state === T || "destory" !== t[e].state && "destory" !== t[e].lastState || delete t[e];
          }), k({}, t);

        default:
          return t;
      }
    }, {});
  }

  var U = {},
      q = function q(e, t) {
    return e.state === t.state;
  },
      V = null,
      W = f.memo(function (e) {
    return e.children;
  }, function () {
    return !0;
  }),
      F = f.memo(function (e) {
    var r = e.cacheId,
        t = e.children,
        n = e.state,
        c = e.dispatch,
        o = e.lastState,
        a = e.load,
        u = void 0 === a ? function () {} : a,
        i = (e.router, f.useRef(null)),
        l = f.useRef(null),
        s = f.useRef(null);
    return f.useEffect(function () {
      return U[r] = function () {
        i.current && l.current && i.current.appendChild(l.current);
      }, function () {
        M[r] && delete M[r], delete U[r];
      };
    }, []), f.useEffect(function () {
      var e, t;
      return n === C ? (t = (e = l.current).parentNode, i.current = t, u(e)) : n === D && (i.current.appendChild(l.current), c("destory" === o ? {
        type: I,
        payload: r
      } : {
        type: P,
        payload: r
      })), function () {
        "destory" === n && (s.current = null);
      };
    }, [n]), O.default.createElement("div", {
      ref: l,
      style: {
        display: n === P ? "none" : "block"
      }
    }, n === C || n === T || n === D || n === P ? O.default.createElement(W, null, t()) : null);
  }, q);

  function H(e) {
    var t = e.children,
        r = j(e, ["children"]),
        e = d(L(), 2),
        n = e[0],
        c = e[1];
    return O.default.createElement(v.Provider, {
      value: {
        cacheState: n,
        cacheDispatch: c
      }
    }, Object.keys(n).map(function (e) {
      return O.default.createElement(F, l({
        cacheId: e,
        key: e
      }, n[e], {
        dispatch: c
      }));
    }), !V && O.default.createElement(G, {
      cacheDispatch: function cacheDispatch(e) {
        return V = e;
      }
    }), f.useMemo(function () {
      return t({
        cacheDispatch: c
      });
    }, [r.location]));
  }

  function G(e) {
    var r = e.children,
        t = e.cacheDispatch,
        n = f.useContext(v) || {};
    return f.useEffect(function () {
      t && A(t) && t(n.cacheDispatch);
    }, []), O.default.createElement(v.Consumer, null, function (e) {
      return t = r, e = e, O.default.isValidElement(t) ? O.default.createElement(t, k({}, e)) : A(t) ? t(e) : null;
      var t;
    });
  }

  var $ = null,
      z = function z(n) {
    return function () {
      return function (t) {
        var e = t.type,
            r = n || V;
        r && ("reset" === e ? ($ && clearTimeout($), $ = setTimeout(function () {
          var e;
          r(t), e = function e() {
            r({
              type: "clear"
            });
          }, Promise.resolve().then(e);
        }, 50)) : r(t));
      };
    };
  },
      t = z(V),
      B = O.default.isValidElement,
      J = O.default.cloneElement,
      Q = O.default.Children.forEach,
      X = function X(e) {
    return e.type.__componentType === m;
  },
      Y = function () {
    s(o, b.Switch);
    var c = h(o);

    function o(e) {
      var a;
      E(this, o);

      for (var t = arguments.length, r = new Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
        r[n - 1] = arguments[n];
      }

      a = c.call.apply(c, [this, e].concat(r));
      var u = e.ishasRouterSwitch,
          i = e.children,
          l = e.cacheDispatch,
          s = a.render;
      return a.render = function () {
        if (u) {
          var r,
              n,
              e,
              c = a.context.router ? (e = a.context.router.history).location : (e = a.props.history, a.props.location);
          Q(i, function (e) {
            var t;
            null == n && B(e) && (t = (r = e).props.path || e.props.from, n = t ? b.matchPath(c.pathname, k(k({}, e.props), {}, {
              path: t
            })) : a.context.match);
          });
          var t = r.props.cacheId || r.props.path,
              o = r.props.scroll;
          return n ? X(r) ? J(r, {
            key: t,
            location: c,
            history: e,
            computedMatch: n,
            cacheDispatch: l,
            match: n,
            iskeep: !0,
            scroll: o
          }) : J(r, {
            key: t,
            location: c,
            history: e,
            computedMatch: n,
            cacheDispatch: l,
            match: n
          }) : null;
        }

        return s.call(R(a));
      }, a;
    }

    return o;
  }();

  Y.__componentType = "KEEPLIVE_ROUTE_SWITCH";

  var r = function r(e) {
    var r = e.children,
        t = e.withoutRoute,
        n = void 0 !== t && t,
        t = e.deep,
        t = void 0 === t || t,
        c = j(e, ["children", "withoutRoute", "deep"]),
        e = f.useMemo(function () {
      var t = !1;
      return Q(r, function (e) {
        if ("Object" === _(e) && A(e.type) && X(e)) return g.default(e.props.cacheId || e.props.path, "keepliveRouter should be a cacheid or paths attribute"), t = !0;
      }), t;
    }, []);
    return f.useEffect(function () {
      return function () {
        try {
          for (var e in U) {
            U[e] && U[e]();
          }
        } catch (e) {}
      };
    }, []), e || t ? O.default.createElement(H, c, function (e) {
      return n ? r : O.default.createElement(Y, l({}, c, e, {
        ishasRouterSwitch: !0
      }), r);
    }) : O.default.createElement(Y, c, r);
  },
      q = b.useHistory || b.__RouterContext ? b.withRouter(r) : r,
      Z = function () {
    s(m, b.Route);
    var v = h(m);

    function m(e) {
      var r;
      E(this, m);

      for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), c = 1; c < t; c++) {
        n[c - 1] = arguments[c];
      }

      S(R(r = v.call.apply(v, [this, e].concat(n))), "cacheMatch", null), S(R(r), "computerMatchRouter", function (e) {
        var t = e.computedMatch,
            r = e.location,
            n = e.path;
        return t || (n ? b.matchPath(r.pathname, e) : null);
      }), S(R(r), "getAndcheckCacheKey", function () {
        var e = r.props,
            t = e.cacheId,
            e = e.path,
            e = t || e;
        return g.default(e, "KeepliveRoute must have a cacheId"), e;
      }), S(R(r), "handerKeepScoll", function (e) {
        r.scrollTarget || (r.scrollTarget = e.target);
      }), S(R(r), "injectDom", function (e) {
        var t = r.props.cacheDispatch;
        r.parentNode && r.parentNode.appendChild(e), t({
          type: T,
          payload: r.getAndcheckCacheKey()
        });
      }), S(R(r), "exportDom", function () {
        var e = r.props.cacheDispatch,
            t = r.getAndcheckCacheKey();
        r.scrollTarget && (M[t] = {
          scrollTarget: r.scrollTarget,
          scrollTop: r.scrollTarget.scrollTop
        });

        try {
          e({
            type: D,
            payload: t
          });
        } catch (e) {}
      }), r.parentNode = null, r.keepliveState = "", r.componentCur = null;
      var o,
          a,
          u = e.children,
          i = e.component,
          l = e.iskeep,
          s = e.render,
          f = e.cacheState,
          p = j(e, ["children", "component", "iskeep", "render", "cacheState"]),
          h = p.cacheDispatch,
          d = p.history,
          y = p.location,
          e = r.computerMatchRouter(e);
      return r.cacheMatch = k({}, e), l && h && f && e && (e = r.getAndcheckCacheKey(), Promise.resolve().then(function () {
        x.forEach(function (e) {
          A(e) && e(k({}, p), r.getAndcheckCacheKey());
        });
      }), !f[e] || f[e] && "destory" === f[e].state ? (o = d && y ? i : b.withRouter(i), y = z(h), p.cacheDispatch = y(), a = k(k({}, p), {}, {
        cacheId: e
      }), h({
        type: w,
        payload: {
          cacheId: e,
          load: r.injectDom.bind(R(r)),
          children: function children() {
            return u ? A(u) ? u(a) : u : i ? O.default.createElement(o, a) : s ? s(a) : null;
          }
        }
      }), r.keepliveState = w) : f[e] && (r.keepliveState = f[e].state), r.render = function () {
        return O.default.createElement("div", {
          ref: function ref(e) {
            return r.parentNode = e;
          }
        });
      }), r;
    }

    return i(m, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function value(e) {
        var t = e.cacheState,
            r = e.iskeep;
        t && r && (this.keepliveState = t[this.getAndcheckCacheKey()].state, e = this.computerMatchRouter(e) || {}, "actived" === this.keepliveState && e && this.cacheMatch && e.path !== this.cacheMatch.path && this.cacheMatch.url);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var e,
            t,
            r = this.props,
            n = r.cacheDispatch,
            c = r.iskeep,
            r = r.scroll;
        c && (this.keepliveState === w ? n({
          type: C,
          payload: {
            cacheId: this.getAndcheckCacheKey()
          }
        }) : this.keepliveState === P && n({
          type: C,
          payload: {
            cacheId: this.getAndcheckCacheKey(),
            load: this.injectDom.bind(this)
          }
        }), r && this.parentNode.addEventListener("scroll", this.handerKeepScoll, !0), r = this.getAndcheckCacheKey(), M[r] && (r = M[r], e = r.scrollTarget, t = r.scrollTop, this.scrollTimer = setTimeout(function () {
          e && (e.scrollTop = t);
        }, 0)));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.iskeep && (this.exportDom(), this.parentNode.removeEventListener("scroll", this.handerKeepScoll, !0), this.scrollTimer && clearTimeout(this.scrollTimer));
      }
    }]), m;
  }(),
      r = function r(t) {
    var e = t.path,
        r = f.useContext(v) || {},
        n = r.cacheState;
    return O.default.createElement(b.Route, {
      path: e,
      render: function render(e) {
        return O.default.createElement(Z, l({}, e, t, r, {
          iskeep: !!n
        }));
      }
    });
  };

  r.__componentType = m, e.GetCacheContext = G, e.KeepaliveRoute = r, e.KeepaliveRouterSwitch = q, e.addKeeperListener = function (t) {
    return x.push(t), function () {
      var e = x.findIndex(function (e) {
        return t === e;
      });
      e && x.splice(e, 1);
    };
  }, e.cacheRouterContext = v, e.keepaliveLifeCycle = function (e) {
    if (!(e.prototype.setState && e.prototype.isReactComponent)) return e;

    var n,
        c,
        t,
        o = null,
        a = (n = e, t = function t() {
      return o;
    }, c = function c() {
      t().apply(void 0, arguments);
    }, function () {
      s(r, n);
      var t = h(r);

      function r(e) {
        return E(this, r), e = t.call(this, e), A(c) && c(R(e)), e;
      }

      return r;
    }()),
        r = function () {
      s(t, O["default"].Component);
      var e = h(t);

      function t() {
        var r;
        return E(this, t), S(R(r = e.call(this)), "handerLifeCycle", function (e) {
          !r.cur || A(e = r.cur[e]) && e.call(r.cur);
        }), S(R(r), "render", function () {
          var e = r.props,
              t = e.forwardedRef,
              e = j(e, ["forwardedRef"]);
          return O.default.createElement(a, l({}, e, {
            ref: t
          }));
        }), r.cur = null, o = function o(e) {
          return r.cur = e;
        }, r;
      }

      return i(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props.cacheId;
          e && (K[e] = this.handerLifeCycle);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          var e = this.props.cacheId;
          delete K[e];
        }
      }]), t;
    }(),
        e = O.default.forwardRef(function (e, t) {
      return O.default.createElement(r, l({
        forwardedRef: t
      }, e));
    });

    return u.default(e, a);
  }, e.useCacheDispatch = t, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});